// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"index-module__FullWidth___Jh4Ra","Article":"index-module__Article___1o7Zg","image":"index-module__image___2BIQ4"};